"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;

var react_1 = __importDefault(require("react"));

exports.SVG = function () {
  return react_1["default"].createElement("svg", {
    viewBox: "0 0 20 20",
    fill: "none"
  }, react_1["default"].createElement("path", {
    d: "M9.32739 5.01468C9.32739 4.67988 9.60639 4.375 9.9973 4.375C10.3723 4.375 10.6726 4.65942 10.6726 5.01468V13.4478L13.8437 10.4441C14.11 10.1919 14.534 10.1919 14.8003 10.4441C15.0666 10.6963 15.0666 11.098 14.8003 11.3502L10.4673 15.4546L10.4555 15.4642C10.3698 15.5338 10.2699 15.5819 10.1658 15.6065L10.1174 15.618H10.1041C10.0936 15.6195 10.0811 15.621 10.0668 15.622C9.96678 15.6308 9.8609 15.6206 9.75934 15.5857C9.66983 15.5564 9.59105 15.5098 9.5217 15.4441L5.20532 11.3555C5.05974 11.226 5 11.0484 5 10.8997C5 10.7354 5.07057 10.5715 5.19971 10.4492C5.466 10.197 5.89003 10.197 6.15631 10.4492L9.32739 13.453V5.01468Z",
    fill: "#727B7F"
  }));
};